import { render, staticRenderFns } from "./CrmOpportunities.vue?vue&type=template&id=cbc6a486&scoped=true&"
import script from "./CrmOpportunities.vue?vue&type=script&lang=js&"
export * from "./CrmOpportunities.vue?vue&type=script&lang=js&"
import style0 from "./CrmOpportunities.vue?vue&type=style&index=0&id=cbc6a486&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc6a486",
  null
  
)

export default component.exports